import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { ContactusComponent } from './contactus/contactus.component';
import { LoginComponent } from './login/login.component';
import { ProvidercornerComponent } from './providercorner/providercorner.component';
import { ServiceComponent } from './service/service.component';
import { TalktodoctorComponent } from './talktodoctor/talktodoctor.component';
import { ChatComponent } from './video-chat/chat/chat.component';
import { RequestappoinmentComponent } from './requestappoinment/requestappoinment.component';
import { TalktodoctorlandingComponent } from './talktodoctorlanding/talktodoctorlanding.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AccountVerificationComponent } from './account-verification/account-verification.component';
import { AdminModule } from './admin/admin.module';
import { ConfirmAppointmentComponent } from './confirm-appointment/confirm-appointment.component';
import { MemberProfileComponent } from './member-profile/member-profile.component';
import { DoctorProfileComponent } from './doctor-profile/doctor-profile.component';
import { MemberAppointmentidComponent } from './member-appointmentid/member-appointmentid.component';
import { DoctorAppointmentidComponent } from './doctor-appointmentid/doctor-appointmentid.component';
// import { WellnessModule } from './wellness_layout/wellness.module';
import { MemberActiveAccountComponent } from './member-active-account/member-active-account.component';
import { AuthGuard } from './api-services/keycloak/auth.guard';
import { ProductsComponent } from './products/products.component';
import { EmrRegistrationComponent } from './emr-registration/emr-registration.component';
import { BookServiceComponent } from './book-service/book-service.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { DoctorRegistrationComponent } from './doctor-registration/doctor-registration.component';
import { TeamComponent } from './team/team.component';
import { AboutComponent } from './about/about.component';
import { MemberAppointmentComponent } from './member-appointment/member-appointment.component';
import { AppointmentByDoctorComponent } from './appointment-by-doctor/appointment-by-doctor.component';
import { DoctorAppointmentComponent } from './doctor-appointment/doctor-appointment.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component'
import { WellnessComponent } from './wellness/wellness.component';
import { RequestErrorComponent } from './request-error/request-error.component';
import { AhyushLoginComponent } from './ahyush-login/ahyush-login.component';
const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  scrollOffset: [0, 64],
};
const routes: Routes = [
  { path: 'products', component: ProductsComponent, data: { title: 'Products' } },
  { path: 'about', component: AboutComponent, data: { title: 'About' } },
  { path: 'team', component: TeamComponent, data: { title: 'Team' } },
  { path: 'error-request', component:RequestErrorComponent, data: { title: 'error-request' } },
  // { path: 'wellness', loadChildren: () => import('./wellness_layout/wellness.module').then(m => m.WellnessModule) },
  
  { path: 'admin', loadChildren: './admin/admin.module#AdminModule', canActivate: [AuthGuard], data: { role: ['AyurwayAdmin'] } },
  
  { path: 'wellness', component: WellnessComponent },
  { path: 'service', component: ServiceComponent, data: { title: 'Services' } },
  { path: 'request-on-appointment', component: TalktodoctorComponent, canActivate: [AuthGuard], data: { title: 'Book-on-appointment', role: ['member'] } },
  { path: 'providercorner', component: ProvidercornerComponent, data: { title: 'Doctor-Register' } },
  { path: 'contactus', component: ContactusComponent, data: { title: 'Contactus' } },
  { path: 'other', component: AhyushLoginComponent, data: { title: 'Others' } },
  { path: 'login', component: LoginComponent, data: { title: 'Login/Signup' } },
  { path: 'registration', component: DoctorRegistrationComponent },
  { path: 'doctorregister-member', component: AppointmentByDoctorComponent, canActivate: [AuthGuard], data: { role: ['doctor'], title: 'doctor-register-member' } },
  { path: 'myappoinment', component: MemberAppointmentComponent, canActivate: [AuthGuard], data: { role: ['member'] } },
  { path: 'doctorappoinment-list', component: DoctorAppointmentComponent, canActivate: [AuthGuard], data: { role: ['doctor'], title: 'appointments' } },
  { path: 'conference-room', component: ChatComponent, canActivate: [AuthGuard], data: { title: 'videochat', role: ['member', 'doctor'] } },
  { path: 'requestappoinment/:id', component: RequestappoinmentComponent, canActivate: [AuthGuard], data: { role: ['member'] } },
  { path: 'confirm-appointment/:id', component: ConfirmAppointmentComponent, canActivate: [AuthGuard], data: { role: ['member'] } },
  { path: 'talktodoctor', component: TalktodoctorlandingComponent },
  { path: 'forgot-Password', component: ForgotPasswordComponent },
  { path: 'activateAccount/:activationId', component: AccountVerificationComponent },
  { path: 'memberActivateAccount/:activationId', component: MemberActiveAccountComponent },
  { path: 'member-profile', component: MemberProfileComponent, canActivate: [AuthGuard], data: { role: ['member'] } },
  { path: 'doctor-profile', component: DoctorProfileComponent, canActivate: [AuthGuard], data: { role: ['doctor'] } },
  { path: 'member-appointment/:id', component: MemberAppointmentidComponent, canActivate: [AuthGuard], data: { role: ['member'] } },
  { path: 'doctor-appointment/:id', component: DoctorAppointmentidComponent, canActivate: [AuthGuard], data: { role: ['doctor'] } },
  { path: 'emr-registration', component: EmrRegistrationComponent },
  { path: 'book-service', component: BookServiceComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent },
  { path: '', redirectTo: 'about', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})

export class AppRoutingModule {

}
